import Ajax from '../common/ajax'
import ApiBase from './api-base'
import Tool from '../common/tool'

export default {
  ...ApiBase,
  model: 'agent',
  pass (agentIds) {
    return Ajax.put(`/api/gradeMaster/v1/${this.model}/pass`, { agentIds })
  },
  unPass (agentIds, msg) {
    return Ajax.put(`/api/gradeMaster/v1/${this.model}/unPass`, { agentIds, msg })
  },
  getAgentList (queryParam) {
    return Ajax.get(`/api/gradeMaster/v1/batch/getAddConfig`, queryParam)
  },
  getAgentPage (queryParam) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/page`, queryParam)
  },
  getAgentAdd (queryParam) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/add`, queryParam)
  },
  getAgentUpdate (queryParam) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/update`, queryParam)
  },
  getAgentDetail (agentId) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/detail/${agentId}`)
  },
  getOperateLog (queryParam) {
    return Ajax.post(`/api/gradeMaster/v1/operateLog/page`, queryParam)
  },
  async getAgentTreeData (queryParam) {
    let agentList = await Ajax.get(`/api/gradeMaster/v1/batch/getAddConfig`, queryParam)
    let set1 = new Set()
    let set2 = new Set()
    let listAll = []
    for (let i in agentList.agentList) {
      let agent = agentList.agentList[i]
      if (!set1.has(agent.parentAddress)) {
        listAll.push({ value: agent.parentAddress, label: agent.parentAddressInfo, parentId: null })
        set1.add(agent.parentAddress)
      }
      if (!set2.has(agent.address)) {
        listAll.push({ value: agent.address, label: agent.addressInfo, parentId: agent.parentAddress })
        set2.add(agent.address)
      }
      listAll.push({ value: agent.agentId, label: agent.agentName, parentId: agent.address })
    }
    let tree = Tool.toTree(listAll, 'value', 'parentId', null, 'children')
    return tree
  },
  getAgentChange (queryParam) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/change`, queryParam)
  }
}
